/*
 * c-cart-line-locked.js
 *
 * カート内で「除外コレクション (航空便など)」に該当する商品の line-item に
 * c-line-item--locked クラスを付与し、CSS で数量・削除ボタンを隠す。
 *
 * データソース: <c-bundle-conflict-modal data-exclude-product-ids='[...]'>
 *
 * トリガー:
 *  - DOMContentLoaded 時の初期適用
 *  - cart:refresh イベント (ミニカート再描画後)
 *  - MutationObserver による .cart / cart-drawer 配下の DOM 変化監視 (フォールバック)
 */
(function () {
  'use strict';

  var LOCKED_CLASS = 'c-line-item--locked';
  var SELECTOR_LINE_ITEM = '.line-item[data-product-id]';
  var SELECTOR_BUNDLE_MODAL = 'c-bundle-conflict-modal';

  function readExcludeIds() {
    var modal = document.querySelector(SELECTOR_BUNDLE_MODAL);
    if (!modal) return null;
    var raw = modal.getAttribute('data-exclude-product-ids');
    if (!raw) return null;
    try {
      var arr = JSON.parse(raw);
      if (!Array.isArray(arr) || arr.length === 0) return null;
      var set = new Set();
      arr.forEach(function (id) {
        var n = Number(id);
        if (!isNaN(n)) set.add(n);
      });
      return set.size > 0 ? set : null;
    } catch (e) {
      return null;
    }
  }

  function applyLocks(root) {
    var excludeIds = readExcludeIds();
    if (!excludeIds) return;
    var scope = root || document;
    var items = scope.querySelectorAll(SELECTOR_LINE_ITEM);
    items.forEach(function (item) {
      var pid = Number(item.getAttribute('data-product-id'));
      if (excludeIds.has(pid)) {
        item.classList.add(LOCKED_CLASS);
      } else {
        item.classList.remove(LOCKED_CLASS);
      }
    });
  }

  // 1. 初期適用
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { applyLocks(); });
  } else {
    applyLocks();
  }

  // 2. cart:refresh イベント (ミニカート再描画後)
  // cart-drawer が innerHTML を置換した後にも発火するため、setTimeout で次のtickに回す
  document.documentElement.addEventListener('cart:refresh', function () {
    setTimeout(function () { applyLocks(); }, 0);
  });

  // 3. MutationObserver フォールバック
  // .cart (main-cart) と cart-drawer 配下の DOM 変化を監視
  var observer = new MutationObserver(function (mutations) {
    var shouldReapply = false;
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.addedNodes && m.addedNodes.length > 0) {
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (node.nodeType === 1 && (node.matches && (node.matches(SELECTOR_LINE_ITEM) || node.querySelector(SELECTOR_LINE_ITEM)))) {
            shouldReapply = true;
            break;
          }
        }
      }
      if (shouldReapply) break;
    }
    if (shouldReapply) applyLocks();
  });

  function startObserver() {
    var cart = document.querySelector('.cart');
    var drawer = document.querySelector('cart-drawer');
    if (cart) observer.observe(cart, { childList: true, subtree: true });
    if (drawer) observer.observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();
